import React, { Fragment } from 'react';
import { RotatingLines } from "react-loader-spinner";
import { ToastContainer,toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import '../components/css/style.css';
import '../components/css/popup.css';

export const xAuth="M@#weh@##dhASD2627@#2024";


/* ############ ecoz service ########## */
export const service="ecoz";
export const countryCode="263";
export const flag="zw";
export const lang="en";
export const serviceId=1;
//export const baseUrl = "/ecozApi";
export const baseUrl = "https://yogamezzw.com/zbbApi"; 


export const brandImages = [
    "/images/brand_1.png",
    "/images/brand_2.png",
    "/images/brand_3.png",
    "/images/brand_4.png",
    "/images/brand_2.png",
    "/images/brand_5.png",
  ];

export const footerImages = [
      "/images/footer_3.png",
      "/images/footer_2.png",
      "/images/footer_1.png",
      "/images/footer_4.png",
      "/images/footer_5.png",
  ];

 
  export const Loader = () => {
    return (
      <div style={{ width: "100px", margin: "auto",}}>
        <RotatingLines
          strokeColor="grey"
          strokeWidth="5"
          animationDuration="0.75"
          width="60"
          visible={true}
        />
      </div>
    )  
  
  }

  export const Popup = () => {
        return (
          <div className="popup-container">
            <div className="popup">
              <div style={{ width: "60px", margin: "auto",}}>
                <RotatingLines
                  strokeColor="grey"
                  strokeWidth="5"
                  animationDuration="0.75"
                  width="60"
                  visible={true}
                />
              </div>
            </div>
          </div>
        )     
    } 

  export const PopupSub = (props) => {
    console.log("sub="+props.subStatus);
    return (     
      <div className="popup-container">
         <div className="popup1">
              {props.subStatus === 2 ?(
              <>
                <div>
                    <spna>Sorry, Your balance is low. Please rechage your <br/> number to access service.</spna>
                </div>
                <div>&nbsp;</div>
                <div className="text-center">               
                    <a className="popupBtnRed" onClick={() => props.redirectTo('')}>CLOSE</a>
                </div>
              </>
              ):props.subStatus === 101 ?(
                <>
                  <div>
                     <h3 className="login-title mb-3 mt-3 text-center">You are about to subscribe <br/>for the YoGamez service for <br/><span className="span-bold">{props.plan}</span><br/> automatically renewable.</h3>
                     <h3 className="login-title mb-3 mt-3 text-center">Are you sure you want to continue?</h3>
                  </div>
                  <div>&nbsp;</div>
                  <div className="popupDiv col-12">               
                   <div className="popupDivLeft col-6"><a className="popupBtnRed" onClick={() => props.redirectTo('/cancel')}>CANCEL</a> </div> 
                   <div className="popupDivRight col-6"><a className="popupBtn" onClick={() => props.sub()}>CONFIRM</a></div> 
                  </div>
                </>
              ):props.subStatus === 102 ?(
                <>
                  <div>
                    <h3 className={props.message.error?"login-title-red mb-3 mt-3 text-center":"login-title mb-3 mt-3 text-center"}>{props.message.message}</h3>
                  </div>
                  <div>&nbsp;</div>
                  <div className="text-center">               
                    <a className="popupBtn" onClick={() => props.redirectTo(props.message.error?"/cancel":"/main")}>OK</a>
                </div>
                </>
              ):props.subStatus === 103 ?(
                <>
                  <div>
                     <h3 className="login-title mb-3 mt-3 text-center">Are you sure you want to unsubscribe?</h3>
                  </div>
                  <div>&nbsp;</div>
                  <div className="popupDiv col-12">               
                   <div className="popupDivLeft col-6"><a className="popupBtnRed" onClick={() => props.redirectTo('/main')}>CANCEL</a> </div> 
                   <div className="popupDivRight col-6"><a className="popupBtn" onClick={() => props.unsub()}>CONFIRM</a></div> 
                  </div>
                </>
              ):
              props.subStatus === 104 ?(
                <>
                  <div>
                     <h3 className="login-title mb-3 mt-3 text-center">Are you sure you want to logout?</h3>
                  </div>
                  <div>&nbsp;</div>
                  <div className="popupDiv col-12">               
                   <div className="popupDivLeft col-6"><a className="popupBtnRed" onClick={() => props.redirectTo('/cancel')}>CANCEL</a> </div> 
                   <div className="popupDivRight col-6"><a className="popupBtn" onClick={() => props.redirectTo('/logout')}>CONFIRM</a></div> 
                  </div>
                </>
              ):
              <>
                <div>
                    <spna>Sorry, YoGamez service is available<br/> only for paid subscribers.</spna>
                </div>
                <div>&nbsp;</div>
                <div className="popupDiv col-12">               
                   <div className="popupDivLeft col-6"><a className="popupBtnRed" onClick={() => props.redirectTo('')}>CANCEL</a> </div> 
                   <div className="popupDivRight col-6"><a className="popupBtn" onClick={() => props.redirectTo('/register')}>SUBSCRIBE</a></div> 
                  </div>
              </>}
         </div>
       </div> 
    )
       
  }
    
  export const Notify = (props) => {
    console.log('props='+props);
    if(props.message)
    {
      if(props.type)
        toast.success(props.message,);
      else
        toast.warning(props.message,);
    }
    // inbuilt-notification
   /* toast.success("successful");
    // inbuilt-notification
    toast.info("GeeksForGeeks");
    // inbuilt-notification
    toast.error("Runtime error");
    // default notification
    toast("Hello Geeks");*/

    return (
      <ToastContainer />
    );
  }
